import { render } from "./Header.vue?vue&type=template&id=0a71e05a&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0a71e05a"

export default script